import axios from "axios";
import { apiRequest } from "@/services/api/apiClient.js";
import {ConnectionEntity} from "@/entities/ConnectionEntity.js";
import internalApi from "@/services/api/internalApi.js";

const entity = new ConnectionEntity();

export async function getConnections({ page = 1, limit = 10, ...filters }) {
    return apiRequest({
        client: API_ISP,
        method: "get",
        url:  entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getConnectionById({id}) {
    return apiRequest({
        client: API_ISP,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}
